import React from 'react';
import { IconButton, Tooltip, COLORS } from 'pvs-design-system';
import { Box, Stack } from '@mui/material';
import ViewList from '@mui/icons-material/ViewList';
import GridView from '@mui/icons-material/GridView';
import type { ViewMode } from './types';

interface LibraryViewToggleProps {
  viewMode: ViewMode;
  onChange: (mode: ViewMode) => void;
}

/** List/grid view switch used by the browse and search pages. */
const LibraryViewToggle: React.FC<LibraryViewToggleProps> = ({ viewMode, onChange }) => (
  <Stack direction="row" gap={0.5}>
    <Tooltip title="List view" placement="bottom" arrow>
      <Box component="span">
        <IconButton
          variant={viewMode === 'list' ? 'primary' : 'secondary'}
          onClick={() => onChange('list')}
          aria-label="List view"
          aria-pressed={viewMode === 'list'}
          sx={{ color: COLORS.purple[700] }}
        >
          <ViewList />
        </IconButton>
      </Box>
    </Tooltip>
    <Tooltip title="Grid view" placement="bottom" arrow>
      <Box component="span">
        <IconButton
          variant={viewMode === 'grid' ? 'primary' : 'secondary'}
          onClick={() => onChange('grid')}
          aria-label="Grid view"
          aria-pressed={viewMode === 'grid'}
          sx={{ color: COLORS.purple[700] }}
        >
          <GridView />
        </IconButton>
      </Box>
    </Tooltip>
  </Stack>
);

export default LibraryViewToggle;
